
import TransferPopup from './transferpopup'

export default TransferPopup;